import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = [
  {
    id: 'PEC',
    value: 'PEC',
  },
];

interface TipoDomicilioDigitaleListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
}

const TipoDomicilioDigitaleListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo Domicilio Digitale',
}: TipoDomicilioDigitaleListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="tipo-domicilio-digitale-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="tipo-domicilio-digitale-list-label"
        id="tipo-domicilio-digitale-list"
        name="tipo-domicilio-digitale-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TipoDomicilioDigitaleListComponent.displayName = 'tipo domicilio digitale list component';

const TipoDomicilioDigitaleList = memo(TipoDomicilioDigitaleListComponent);

export default TipoDomicilioDigitaleList as typeof TipoDomicilioDigitaleListComponent;
